import { browser } from '$app/environment';
import { env } from '$env/dynamic/public';
import { ApiError } from '$lib/api';

type PostHog = typeof import('posthog-js').default;
let ph: PostHog | null = null;

export async function initPostHog(apiKey: string | undefined): Promise<void> {
	console.debug('[PostHog] initPostHog called', { browser, apiKey: apiKey ? `${apiKey.slice(0, 8)}...` : undefined, alreadyInit: !!ph });
	if (!browser || !apiKey || ph) return;
	try {
		const { default: posthog } = await import('posthog-js');
		ph = posthog;
		posthog.init(apiKey, {
			api_host: 'https://us.i.posthog.com',
			person_profiles: 'identified_only',
			capture_pageview: true,
			capture_pageleave: true,
			autocapture: false,
			session_recording: { maskAllInputs: true },
		});
		console.debug('[PostHog] initialized successfully, ph set =', !!ph);
	} catch (err) {
		console.error('[PostHog] init failed:', err);
	}
}

export function identifyUser(userId: string, email: string, isDemo = false) {
	ph?.identify(userId, isDemo ? { is_demo: true } : { email, is_demo: false });
}

export function resetUser() {
	ph?.reset();
}

export function track(event: string, properties?: Record<string, unknown>) {
	ph?.capture(event, properties);
}

/**
 * Open the configured external feedback form and retain an analytics signal
 * indicating where the request started.
 *
 * @param source where the request originated (e.g. 'help', 'settings')
 */
export function requestFeedback(source: string) {
	const feedbackUrl = env.PUBLIC_FEEDBACK_URL;
	if (!browser || !feedbackUrl) return;

	ph?.capture('feedback_link_opened', { source });
	window.open(feedbackUrl, '_blank', 'noopener,noreferrer');
}

export function trackFailure(event: string, err: unknown, properties?: Record<string, unknown>) {
	const code = err instanceof ApiError ? err.code : 'unknown';
	ph?.capture(event, { ...properties, failureCode: code });
}
